module.exports = __webpack_public_path__ + "img/boy selected.f42a730a.png";